
import { defineComponent } from 'vue'
import RelojDisplay from '@/components/RelojDisplay.vue'

export default defineComponent({
  components: { RelojDisplay, },
  watch: {
    $route: {
      immediate: true,
      handler (to, _from) {
        document.title = to.meta.title || this.$t('garchivo')
      },
    },
  },
})
